import React from "react";
import fields from "../../json/SubscribeEmailList.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const EditMemberForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
}) => {
  const { formdata } = fields;
  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Update Member</HeadingOne>}
    >
      {formdata.map((field) => (
        <FormInput
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
        />
      ))}

      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditMemberForm;